/**
 * src/hooks/useResponsive.ts — viewport breakpoint helper (W5 web ergonomics).
 *
 * Drives wide-screen (desktop/tablet web) layout decisions: master-detail vs stacked, dense table
 * vs cards, etc. Backed by useWindowDimensions so it reacts to browser resize and device rotation.
 * On phones isWide is false, so native layouts are unchanged.
 */
import { useWindowDimensions } from 'react-native';
import { theme } from '../theme';

export interface Responsive {
  width: number;
  height: number;
  /** True on tablet/desktop-width viewports (≥ theme.layout.wideBreakpoint). */
  isWide: boolean;
}

export function useResponsive(): Responsive {
  const { width, height } = useWindowDimensions();
  return { width, height, isWide: width >= theme.layout.wideBreakpoint };
}
